export default __webpack_public_path__ + "static/media/notetaker.140be174.png";